<script setup lang="ts">
import { onMounted, ref, watch } from 'vue';
import { useSharedState } from 'composables/useSharedState';
import { QrCodeProps } from './QrCodeProps';
import QRCode, { QRCodeRenderersOptions } from 'qrcode';
import { useLogger } from 'composables/useLogger';

const props = withDefaults(defineProps<QrCodeProps>(), {
  type: 'svg',
  width: 200,
  margin: 1
});

const state = useSharedState<QrCodeProps>(props);
const logger = useLogger('QrCodeComponent');

const canvasRef = ref<HTMLCanvasElement | null>(null);
const createRenderOptions = (): QRCodeRenderersOptions => ({
  width: state.width?.value || props.width,
  errorCorrectionLevel: 'H' as QRCode.QRCodeErrorCorrectionLevel,
  margin: state.margin?.value || props.margin
});

const renderQrCode = () => {
  const renderOptions = createRenderOptions();
  if (!canvasRef.value) return;
  QRCode.toCanvas(canvasRef.value, props.data, renderOptions, error => {
    if (error) logger.error('Error generating QR code:', error);
  });
};

onMounted(() => {
  renderQrCode();
});

watch(() => ({ ...props }), renderQrCode, { deep: true });
</script>

<template>
  <canvas ref="canvasRef"></canvas>
</template>
